import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Logo da marca. Por padrão é um link para "/". Quando usado DENTRO de outro link (ex.: o header do
 * AdminLayout, que já envolve o logo num <Link> para a home do usuário), passe `to={null}` para renderizar
 * um container sem âncora própria — evita <a> dentro de <a> (HTML inválido).
 */
export function Logo({
  className,
  showWord = true,
  to = "/",
}: {
  className?: string;
  showWord?: boolean;
  to?: string | null;
}) {
  const content = (
    <>
      <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-primary shadow-glow">
        <Sprout className="h-5 w-5 text-primary-foreground" />
      </span>
      {showWord && (
        <span className="font-display text-lg font-bold tracking-tight text-foreground">
          Natur<span className="text-primary-glow">express</span>
        </span>
      )}
    </>
  );
  const classes = cn("inline-flex items-center gap-2 group", className);
  if (to === null) {
    return <span className={classes}>{content}</span>;
  }
  return (
    <Link to={to} className={classes}>
      {content}
    </Link>
  );
}
